var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { Item, ItemSubItemService } from './item-subitem.service';
import { ItemSubItemDirective } from './item-subitem.directive';
import { ValidationService } from '../../service/validation.service';
var ItemSubItemComponent = /** @class */ (function (_super) {
    __extends(ItemSubItemComponent, _super);
    function ItemSubItemComponent(router, route, logger, action, message, page, service, validService) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.validService = validService;
        _this.items = [];
        _this.total = 0;
        _this.price = 0;
        _this.readonly = false;
        _this.priceComp = '';
        _this.seq = 1;
        return _this;
    }
    ItemSubItemComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.setCompRec(false);
        this.subsc = this.service.observable.subscribe(function (flg) {
            if (flg) {
                _this.addError(true);
            }
        });
    };
    ItemSubItemComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        if (meta.components) {
            var priceComp = jsonpath.value(meta.components, '$..[?(@.component=="ItemPriceComponent")]');
            this.priceComp = '';
            if (priceComp && priceComp['name']) {
                this.priceComp = priceComp['name'];
            }
        }
    };
    ItemSubItemComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
    };
    ItemSubItemComponent.prototype.onSubscribe = function (data) {
        this.items = [];
        this.total = 0;
        this.price = 0;
        this.seq = 1;
        if (typeof data['items'] !== 'undefined' && data['items'] instanceof Array) {
            this.items = data['items'];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                this.calDiff(item);
                if (typeof item.parent_item_id !== 'undefined' && typeof item.$type === 'undefined') {
                    item.$type = "put" /* Put */;
                }
                item.$seq = this.seq++;
            }
        }
        if (this.items.length === 0) {
            this.items.push(Object.assign(new Item(), { $seq: this.seq++ }));
        }
        this.setCompRec(false);
    };
    ItemSubItemComponent.prototype.trackByItem = function (index, item) {
        return item.$seq;
    };
    ItemSubItemComponent.prototype.onModeSubscribe = function (mode) {
        this.readonly = false;
        if (mode === 'confirm') {
            this.readonly = true;
        }
    };
    ItemSubItemComponent.prototype.onChangeSubscribe = function (compRec) {
        var data = compRec[this.priceComp];
        if (typeof data !== 'undefined' && typeof data['items'] !== 'undefined' && data['items'] instanceof Array && data['items'].length > 0) {
            var priceComp = JSOG.parse(JSON.stringify(data['items']));
            var priceFirst = priceComp.shift();
            priceComp.sort(function (a, b) {
                var a_date = a['start_date'];
                var b_date = b['start_date'];
                if (typeof a_date === 'undefined') {
                    return -1;
                }
                if (typeof b_date === 'undefined') {
                    return 1;
                }
                a_date = new Date(a_date);
                b_date = new Date(b_date);
                if (a_date < b_date) {
                    return -1;
                }
                if (a_date > b_date) {
                    return 1;
                }
                return 0;
            });
            var find = false;
            var price = 0;
            for (var i = priceComp.length - 1; i >= 0; i--) {
                var pComp = priceComp[i];
                if (pComp['type'] === "delete" /* Delete */) {
                    continue;
                }
                if (typeof pComp['start_date'] === 'undefined') {
                    continue;
                }
                var s_date = new Date(pComp['start_date']);
                var now = new Date();
                if (s_date <= now) {
                    price = pComp['price'] ? pComp['price'] : 0;
                    find = true;
                    break;
                }
            }
            if (!find) {
                price = priceFirst['price'] ? priceFirst['price'] : 0;
            }
            if (this.price !== price) {
                this.price = price;
                this.service.setPrice(this.total, this.price);
                this.addError(true);
                this.validService.afterValidation();
            }
        }
    };
    ItemSubItemComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    ItemSubItemComponent.prototype.onAdd = function () {
        this.items.push(Object.assign(new Item(), { $seq: this.seq++ }));
        this.setCompRec(true);
    };
    ItemSubItemComponent.prototype.onDelete = function (index) {
        if (typeof this.items[index].parent_item_id === 'undefined' || this.items[index].parent_item_id === null) {
            this.items.splice(index, 1);
        }
        else {
            this.items[index].$type = "delete" /* Delete */;
        }
        this.calTotal();
        this.setCompRec(true);
    };
    ItemSubItemComponent.prototype.onSearch = function (index) {
        this.index = index;
        this.action.firstAction(this.componentName + '#modal#open');
    };
    ItemSubItemComponent.prototype.onSelect = function (e) {
        this.setItem(e, this.index);
        this.setCompRec(true);
    };
    ItemSubItemComponent.prototype.onChange = function (e, key, index) {
        if (key === 'item_no') {
            this.setItem(e.val, index);
        }
        else {
            this.items[index][key] = e.val;
            if (key === 'item_price') {
                this.calDiff(this.items[index]);
            }
            else if (key === 'item_num') {
                this.calSubTotal(this.items[index]);
            }
        }
        this.setCompRec(true);
    };
    ItemSubItemComponent.prototype.setItem = function (data, index) {
        this.items[index]['child_item_id'] = data['item_id'] || '';
        this.items[index]['item_no'] = data['item_no'] || '';
        this.items[index]['item_name'] = data['item_name'] || '';
        this.items[index]['standard_price'] = data['price'] || 0;
        this.items[index]['item_price'] = this.items[index]['standard_price'];
        this.items[index]['item_num'] = 1;
        this.calDiff(this.items[index]);
    };
    ItemSubItemComponent.prototype.calDiff = function (item) {
        item.item_diff_price = item.item_price - item.standard_price;
        this.calSubTotal(item);
    };
    ItemSubItemComponent.prototype.calSubTotal = function (item) {
        item.item_subtotal = item.item_price * item.item_num;
        this.calTotal();
    };
    ItemSubItemComponent.prototype.calTotal = function () {
        this.total = 0;
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var item = _a[_i];
            if (item.$type !== "delete" /* Delete */) {
                this.total += item.item_subtotal;
            }
        }
        this.service.setPrice(this.total, this.price);
    };
    ItemSubItemComponent.prototype.setCompRec = function (checkFlg) {
        this.addError(checkFlg);
        this.action.setCompRec(this.componentName, { items: this.items });
    };
    ItemSubItemComponent.prototype.addError = function (checkFlg) {
        if (this.dir) {
            var items = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                if (item.$type !== "delete" /* Delete */) {
                    items.push(item);
                }
            }
            var requiredFlg = checkFlg ? (items.length === 0) : false;
            var priceFlg = checkFlg ? (this.total !== this.price) : false;
            this.dir.addRequiredError(requiredFlg, this.msgSnapshot['ColumnComponent.error.required']);
            this.dir.addPriceError(priceFlg, this.msgSnapshot['ItemSubItemComponent.error.price']);
        }
    };
    ItemSubItemComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.subsc.unsubscribe();
    };
    ItemSubItemComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'item-subitem',
                    template: "<form id=\"{{ componentName }}\" subitemDir>\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <dl class=\"form\">\n        <dt class=\"form_dt\">\n          <column-formtitle [key]=\"'list'\" [col]=\"{\n            label: (msg | async)['ItemSubItemComponent.label.item_set'],\n            required: true\n          }\" [msg]=\"(msg | async)\"></column-formtitle>\n        </dt>\n        <dd class=\"form_dd subitemRequiredError\"></dd>\n      </dl>\n    </div>\n  </div>\n  <div class=\"tableWrapper\">\n    <table class=\"tableWrapper_table\">\n      <thead>\n      <tr data-href=\"#\">\n        <th [hidden]=\"readonly\" scope=\"col\"></th>\n        <th [hidden]=\"readonly\" scope=\"col\"></th>\n        <th scope=\"col\"><a class=\"-fixed\">{{ (msg | async)['ItemSubItemComponent.label.item_no'] }}</a></th>\n        <th scope=\"col\"><a class=\"-fixed\">{{ (msg | async)['ItemSubItemComponent.label.item_name'] }}</a></th>\n        <th scope=\"col\"><a class=\"-fixed\">{{ (msg | async)['ItemSubItemComponent.label.item_standard_price'] }}</a></th>\n        <th scope=\"col\"><a class=\"-fixed\">{{ (msg | async)['ItemSubItemComponent.label.item_price'] }}</a></th>\n        <th scope=\"col\"><a class=\"-fixed\">{{ (msg | async)['ItemSubItemComponent.label.item_diff_price'] }}</a></th>\n        <th scope=\"col\"><a class=\"-fixed\">{{ (msg | async)['ItemSubItemComponent.label.item_num'] }}</a></th>\n        <th scope=\"col\"><a class=\"-fixed\">{{ (msg | async)['ItemSubItemComponent.label.item_subtotal'] }}</a></th>\n      </tr>\n      </thead>\n      <tbody>\n      <ng-template ngFor let-item [ngForOf]=\"items\" let-index=\"index\" [ngForTrackBy]=\"trackByItem\">\n        <tr *ngIf=\"item.$type !== 'delete'\" data-href=\"#\" class=\"tr_cursorDefault\">\n          <td [hidden]=\"readonly\" class=\"tableWrapper_iconTd\">\n            <a href=\"javascript:void(0);\" (click)=\"onDelete(index)\"><img src=\"img/icon_delete.svg\" alt=\"\" width=\"18\"></a>\n          </td>\n          <td [hidden]=\"readonly\" class=\"tableWrapper_iconTd\">\n            <a href=\"javascript:void(0);\" (click)=\"onSearch(index)\"><img src=\"img/icon_search.svg\" alt=\"\" width=\"18\"></a>\n          </td>\n          <td>\n            <dl class=\"form\">\n              <dt></dt>\n              <dd class=\"form_dd\">\n                <ul *ngIf=\"!readonly\">\n                  <li class=\"form_li form_li-w150\">\n                    <item-subitem-select2 [key]=\"'list'\" [col]=\"{\n                      key: 'item_no-' + item.$seq,\n                      controlType: 'select2',\n                      required: true,\n                      params: {formClass: {width: '150'}}\n                    }\" [val]=\"item['item_no']\" [msg]=\"(msg | async)\" (changeSelect)=\"onChange($event, 'item_no', index)\"></item-subitem-select2>\n                  </li>\n                </ul>\n                <ul *ngIf=\"readonly\">\n                  <li class=\"form_li\">\n                    <column-formreadonly [col]=\"{controlType: 'text'}\" [val]=\"item['item_no']\" [msg]=\"(msg | async)\"></column-formreadonly>\n                  </li>\n                </ul>\n              </dd>\n            </dl>\n          </td>\n          <td>\n            <dl class=\"form\">\n              <dt></dt>\n              <dd class=\"form_dd\">\n                <ul>\n                  <li class=\"form_li\">\n                    <column-formlabel [key]=\"'list'\" [col]=\"{\n                      key: 'item_name-' + item.$seq,\n                      controlType: 'label'\n                    }\" [val]=\"item['item_name']\" [msg]=\"(msg | async)\"></column-formlabel>\n                  </li>\n                </ul>\n              </dd>\n            </dl>\n          </td>\n          <td>\n            <dl class=\"form\">\n              <dt></dt>\n              <dd class=\"form_dd\">\n                <ul>\n                  <li class=\"form_li\">\n                    <column-formlabel [key]=\"'list'\" [col]=\"{\n                      key: 'standard_price-' + item.$seq,\n                      controlType: 'label'\n                    }\" [val]=\"item['standard_price']\" [msg]=\"(msg | async)\"></column-formlabel>\n                  </li>\n                </ul>\n              </dd>\n            </dl>\n          </td>\n          <td>\n            <dl class=\"form\">\n              <dt></dt>\n              <dd class=\"form_dd\">\n                <ul *ngIf=\"!readonly\">\n                  <li class=\"form_li form_li-w100\">\n                    <column-number [key]=\"'list'\" [col]=\"{\n                      key: 'item_price-' + item.$seq,\n                      controlType: 'number',\n                      required: true,\n                      params: {options: {min: 0}, formClass: {width: '100'}}\n                    }\" [val]=\"item['item_price']\" [msg]=\"(msg | async)\" (changeVal)=\"onChange($event, 'item_price', index)\"></column-number>\n                  </li>\n                </ul>\n                <ul *ngIf=\"readonly\">\n                  <li class=\"form_li\">\n                    <column-formreadonly [col]=\"{controlType: 'number'}\" [val]=\"item['item_price']\" [msg]=\"(msg | async)\"></column-formreadonly>\n                  </li>\n                </ul>\n              </dd>\n            </dl>\n          </td>\n          <td>\n            <dl class=\"form\">\n              <dt></dt>\n              <dd class=\"form_dd\">\n                <ul>\n                  <li class=\"form_li\" [style.color]=\"item['item_price'] > item['standard_price'] ? 'red' : ''\">\n                    <column-formlabel [key]=\"'list'\" [col]=\"{\n                      key: 'item_diff_price-' + item.$seq,\n                      controlType: 'label'\n                    }\" [val]=\"item['item_diff_price']\" [msg]=\"(msg | async)\"></column-formlabel>\n                  </li>\n                </ul>\n              </dd>\n            </dl>\n          </td>\n          <td>\n            <dl class=\"form\">\n              <dt></dt>\n              <dd class=\"form_dd\">\n                <ul *ngIf=\"!readonly\">\n                  <li class=\"form_li form_li-w100\">\n                    <column-number [key]=\"'list'\" [col]=\"{\n                      key: 'item_num-' + item.$seq,\n                      controlType: 'number',\n                      required: true,\n                      params: {options: {min: 1}, formClass: {width: '100'}}\n                    }\" [val]=\"item['item_num']\" [msg]=\"(msg | async)\" (changeVal)=\"onChange($event, 'item_num', index)\"></column-number>\n                  </li>\n                </ul>\n                <ul *ngIf=\"readonly\">\n                  <li class=\"form_li\">\n                    <column-formreadonly [col]=\"{controlType: 'number'}\" [val]=\"item['item_num']\" [msg]=\"(msg | async)\"></column-formreadonly>\n                  </li>\n                </ul>\n              </dd>\n            </dl>\n          </td>\n          <td>\n            <dl class=\"form\">\n              <dt></dt>\n              <dd class=\"form_dd\">\n                <ul>\n                  <li class=\"form_li\">\n                    <column-formlabel [key]=\"'list'\" [col]=\"{\n                      key: 'item_subtotal-' + item.$seq,\n                      controlType: 'label'\n                    }\" [val]=\"item['item_subtotal']\" [msg]=\"(msg | async)\"></column-formlabel>\n                  </li>\n                </ul>\n              </dd>\n            </dl>\n          </td>\n        </tr>\n      </ng-template>\n      <tr data-href=\"#\" class=\"tr_cursorDefault\">\n        <td [hidden]=\"readonly\"></td>\n        <td [hidden]=\"readonly\"></td>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td>{{ (msg | async)['ItemSubItemComponent.label.item_total'] }}</td>\n        <td>\n          <dl class=\"form\">\n            <dt></dt>\n            <dd class=\"form_dd\">\n              <ul>\n                <li class=\"form_li\" [style.color]=\"total !== price ? 'red' : ''\">\n                  <column-formlabel [key]=\"'list'\" [col]=\"{\n                    key: 'total',\n                    controlType: 'label'\n                  }\" [val]=\"total\" [msg]=\"(msg | async)\"></column-formlabel>\n                </li>\n              </ul>\n            </dd>\n          </dl>\n        </td>\n      </tr>\n      </tbody>\n    </table>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-sm-2\">\n      <p *ngIf=\"!readonly\">\n        <button class=\"addBtn\" type=\"button\" (click)=\"onAdd()\"></button>\n      </p>\n    </div>\n    <div class=\"col-sm-10 -txtalnright -pt-1 subitemPriceError\"></div>\n  </div>\n</form>\n<item-modal [componentName]=\"componentName + '#modal'\" [component]=\"{name: componentName + '#modal'}\" (modalSubmit)=\"onSelect($event)\"></item-modal>\n"
                }] }
    ];
    /** @nocollapse */
    ItemSubItemComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ItemSubItemService },
        { type: ValidationService }
    ]; };
    ItemSubItemComponent.propDecorators = {
        dir: [{ type: ViewChild, args: [ItemSubItemDirective,] }]
    };
    return ItemSubItemComponent;
}(ContentBaseComponent));
export { ItemSubItemComponent };
//# sourceMappingURL=item-subitem.component.js.map